module.exports = __webpack_public_path__ + "img/title.2b7f4295.jpg";